import { Deserializable } from '../deserializable';
import { Note } from '../interfaces/note';
import { DirectCustomer } from './direct-customer.model';

export class DirectCustomerNote implements Note, Deserializable {
  public UserNoteID: number;
  public DirectCustomerNoteID: number;
  public DirectCustomerID?: number;
  public Notes: string;
  public CreatedDate?: Date;
  public CreatedBy: string;
  public DirectCustomer: DirectCustomer;
  public Time: number;

  public deserialize(input: any): this {
    Object.assign(this, input);
    this.Time = input.CreatedDate ? new Date(input.CreatedDate).getTime() : undefined;

    return this;
  }
}
